<script setup lang="ts">
/** 공통 회사 헤더 — Company Name + [Registration No. (+ 구번호)] + (Incorporated in Malaysia).
 *  old_registration_no(구 등록번호)는 entity 에 값이 있을 때만 괄호로 표시. */
import { computed, inject } from 'vue';
import { OTC_DOC_CTX } from '../otcContext';
import OtcDocVarField from '../OtcDocVarField.vue';

withDefaults(defineProps<{ showReg?: boolean }>(), { showReg: true });

const ctx = inject(OTC_DOC_CTX)!;
const hasOldReg = computed(() => !!String(ctx.valueOf('old_registration_no') || '').trim());
</script>

<template>
  <div class="otc-head">
    <div class="otc-company"><OtcDocVarField field-key="company_name" /></div>
    <div v-if="showReg" class="otc-meta">
      [Company Registration No. <OtcDocVarField field-key="company_registration_no" /><template v-if="hasOldReg"> (<OtcDocVarField field-key="old_registration_no" />)</template>]
    </div>
    <div class="otc-meta italic">(Incorporated in Malaysia)</div>
  </div>
</template>

<style scoped>
.otc-head { text-align:center; margin-bottom:16px; }
.otc-company { font-size:16px; font-weight:800; margin:2px 0; }
.otc-meta { font-size:11px; color:#333; }
.otc-meta.italic { font-style:italic; }
</style>
